import { Modal } from "theme";

var MarketingPopup = class extends Modal {
  connectedCallback() {
    super.connectedCallback();
    this.setupDismissActions();
    if (this.shouldAppearAutomatically) {
      this.setupTriggers();
    }
  }
  get storageKey() {
    return this.getAttribute("storage-key") || "theme:marketing-popup";
  }
  get shouldAppearAutomatically() {
    if (localStorage.getItem(`${this.storageKey}:filled`) === "true") {
      return false;
    }
    if (this.hasAttribute("only-once") && localStorage.getItem(`${this.storageKey}:appeared`) === "true") {
      return false;
    }
    if (localStorage.getItem(`${this.storageKey}:dismissed`) === "true") {
      return false;
    }
    return true;
  }
  get apparitionDelay() {
    return parseInt(this.getAttribute("apparition-delay") || "0", 10) * 1e3;
  }
  get triggerType() {
    return this.getAttribute("trigger") || "exit_intent";
  }
  shouldShowOnDevice() {
    if (this.getAttribute("show-on-mobile") === "true") {
      return true;
    }
    return window.matchMedia("(min-width: 700px)").matches;
  }
  setupTriggers() {
    if (!this.shouldShowOnDevice()) {
      return;
    }
    const showPopup = () => {
      if (!this.shouldAppearAutomatically || this.open) {
        return;
      }
      this.show();
    };
    if (this.triggerType === "delay" || this.triggerType === "both") {
      window.setTimeout(showPopup, this.apparitionDelay);
    }
    if (this.triggerType === "exit_intent" || this.triggerType === "both") {
      const onMouseOut = (event) => {
        if (event.clientY <= 0 && !event.relatedTarget) {
          showPopup();
          document.removeEventListener("mouseout", onMouseOut);
        }
      };
      document.addEventListener("mouseout", onMouseOut, { signal: this.abortController.signal });
    }
  }
  setupDismissActions() {
    this.querySelector("[data-action='decline']")?.addEventListener(
      "click",
      () => {
        localStorage.setItem(`${this.storageKey}:dismissed`, "true");
        this.hide();
      },
      { signal: this.abortController.signal }
    );
  }
  attributeChangedCallback(name, oldValue, newValue) {
    super.attributeChangedCallback(name, oldValue, newValue);
    if (name === "open" && this.open) {
      localStorage.setItem(`${this.storageKey}:appeared`, "true");
    }
  }
};

if (!window.customElements.get("marketing-popup")) {
  window.customElements.define("marketing-popup", MarketingPopup);
}
